<template>
  <div class="home">
    <tabbar></tabbar>
    <userinfo></userinfo>
  </div>
</template>

<script>
import tabbar from '@/components/Tabbar' 
import userinfo from '@/components/userInfo' 
export default {
  components:{
    tabbar,
    userinfo
  },
   data() {
    return {
      active: 0,
      icon: {
        active: 'https://img.yzcdn.cn/vant/user-active.png',
        inactive: 'https://img.yzcdn.cn/vant/user-inactive.png'
      },
      userInfo:'',
      token:'',
    }
  },
  mounted() {
    
    if (localStorage.getItem("userInfo")) {
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
    }
    this.usertoken = this.userInfo.token;
    
  },
  methods:{
  
    
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.van-tabs--line /deep/ .van-tabs__wrap {
    height: 40px !important;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding-left: 15px;
  margin: 5px 0;
  text-align: left;
}
li {
  display: inline-block;
  margin-right: 10px;
  line-height: 20px;
}
a {
  color: #42b983;
}
.subjectabs{
  width: 50px;
  height: 35px;
  position: absolute;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/personage/personage.vue